var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.30417255,5 C5.84246332,5.40751298 5.47555361,5.91995033 5.24075547,6.5 L3.16666667,6.5 C2.33823954,6.5 1.66666667,7.17157288 1.66666667,8 C1.66666667,8.82842712 2.33823954,9.5 3.16666667,9.5 L6.83333333,9.5 C7.49680841,9.5 8.05967448,9.0692416 8.25751975,8.47213658 C8.53108788,8.181481 8.91934962,8 9.34999854,8 L10,8 C10,9.65685425 8.65685425,11 7,11 L3,11 C1.34314575,11 0,9.65685425 0,8 C0,6.34314575 1.34314575,5 3,5 L6.30417255,5 Z M9.69582745,11 C10.1575367,10.592487 10.5244464,10.0800497 10.7592445,9.5 L12.8333333,9.5 C13.6617605,9.5 14.3333333,8.82842712 14.3333333,8 C14.3333333,7.17157288 13.6617605,6.5 12.8333333,6.5 L9.16666667,6.5 C8.50319159,6.5 7.94032552,6.9307584 7.74248025,7.52786342 C7.46891212,7.818519 7.08065038,8 6.65000146,8 L6,8 C6,6.34314575 7.34314575,5 9,5 L13,5 C14.6568542,5 16,6.34314575 16,8 C16,9.65685425 14.6568542,11 13,11 L9.69582745,11 Z",
    transform: "rotate(-45 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.484063a462353fd9ac5899742fb12e7a.svg";
export { ForwardRef as ReactComponent };